import {
  BusinessChart,
  Calendar,
  CalendarUpcoming,
  Check,
  CheckCircle2,
  Heart,
  Inbox,
  Project,
  Repeat,
  Target,
  Timeline,
  TodoList2,
} from '@griply/assets';
import { Paths } from 'shared/routes/paths';

import {
  MainNavigationItemId,
  MobileNavigationItem,
  NavigationItem,
  SubNavigationItem,
} from './types/navigation-item';

export const inboxNavigationItem: SubNavigationItem = {
  id: MainNavigationItemId.Inbox,
  translationLabel: 'general.menu.navigation.todo.inbox',
  link: Paths.Inbox,
  pathsToMatch: [Paths.Inbox],
  icon: Inbox,
};

export const mainNavigation: NavigationItem[] = [
  {
    id: MainNavigationItemId.Todo,
    translationLabel: 'general.menu.navigation.todo',
    subItems: [
      {
        id: MainNavigationItemId.Today,
        translationLabel: 'general.menu.navigation.todo.today',
        link: Paths.Home,
        pathsToMatch: [Paths.Home],
        icon: Calendar,
      },
      {
        id: MainNavigationItemId.AllTasks,
        translationLabel: 'general.menu.navigation.todo.all-tasks',
        link: Paths.AllTasks,
        pathsToMatch: [Paths.AllTasks],
        icon: TodoList2,
      },
      {
        id: MainNavigationItemId.Completed,
        translationLabel: 'general.menu.navigation.todo.completed',
        link: Paths.Completed,
        pathsToMatch: [Paths.Completed],
        icon: Check,
      },
    ],
  },
  {
    id: MainNavigationItemId.Plan,
    translationLabel: 'general.menu.navigation.plan',
    subItems: [
      {
        id: MainNavigationItemId.Upcoming,
        translationLabel: 'general.menu.navigation.todo.upcoming',
        link: Paths.Upcoming,
        pathsToMatch: [Paths.Upcoming],
        icon: CalendarUpcoming,
      },
      {
        id: MainNavigationItemId.Timeline,
        translationLabel: 'general.menu.navigation.plan.timeline',
        link: Paths.Timeline,
        pathsToMatch: [Paths.Timeline],
        icon: Timeline,
      },
    ],
  },
  {
    id: MainNavigationItemId.MyLife,
    translationLabel: 'general.menu.navigation.my-life',
    subItems: [
      {
        id: MainNavigationItemId.LifeAreas,
        translationLabel: 'general.menu.navigation.my-life.life-areas',
        link: Paths.LifeAreas,
        pathsToMatch: [Paths.LifeAreas],
        icon: Heart,
      },
      {
        id: MainNavigationItemId.Goals,
        translationLabel: 'general.menu.navigation.my-life.goals',
        link: Paths.Goals,
        pathsToMatch: [
          Paths.Goals,
          Paths.GoalsCompleted,
          Paths.GoalsArchived,
          Paths.GoalsThisYear,
          Paths.GoalsNextYear,
          Paths.GoalsUnplanned,
        ],
        icon: Target,
      },
      {
        id: MainNavigationItemId.Projects,
        translationLabel: 'general.menu.navigation.my-life.projects',
        link: Paths.Projects,
        pathsToMatch: [Paths.Projects],
        icon: Project,
      },
      {
        id: MainNavigationItemId.Habits,
        translationLabel: 'general.menu.navigation.my-life.habits',
        link: Paths.Habits,
        pathsToMatch: [Paths.Habits],
        icon: Repeat,
      },
      {
        id: MainNavigationItemId.Insights,
        translationLabel: 'general.menu.navigation.my-life.insights',
        link: Paths.Insights,
        pathsToMatch: [Paths.Insights],
        icon: BusinessChart,
      },
    ],
  },
];

export const mainMobileNavigation: MobileNavigationItem[] = [
  {
    id: MainNavigationItemId.Todo,
    translationLabel: 'general.menu.navigation.todo',
    link: Paths.Home,
    pathsToMatch: [
      Paths.Home,
      Paths.Inbox,
      Paths.Upcoming,
      Paths.AllTasks,
      Paths.Completed,
    ],
    icon: CheckCircle2,
  },
  {
    id: MainNavigationItemId.Habits,
    translationLabel: 'general.menu.navigation.my-life.habits',
    link: Paths.Habits,
    pathsToMatch: [Paths.Habits],
    icon: Repeat,
  },
  {
    id: MainNavigationItemId.Goals,
    translationLabel: 'general.menu.navigation.my-life.goals',
    link: Paths.Goals,
    pathsToMatch: [
      Paths.Goals,
      Paths.GoalsCompleted,
      Paths.GoalsArchived,
      Paths.GoalsThisYear,
      Paths.GoalsNextYear,
      Paths.GoalsUnplanned,
    ],
    icon: Target,
  },
  {
    id: MainNavigationItemId.Projects,
    translationLabel: 'general.menu.navigation.my-life.projects',
    link: Paths.Projects,
    pathsToMatch: [Paths.Projects],
    icon: Project,
  },
  {
    id: MainNavigationItemId.LifeAreas,
    translationLabel: 'general.menu.navigation.my-life.life-areas',
    link: Paths.LifeAreas,
    pathsToMatch: [Paths.LifeAreas],
    icon: Heart,
  },
  {
    id: MainNavigationItemId.Insights,
    translationLabel: 'general.menu.navigation.my-life.insights',
    link: Paths.Insights,
    pathsToMatch: [Paths.Insights],
    icon: BusinessChart,
  },
];
